import api from './api';

const presentationService = {
  getByProduct: async (productId) => {
    const response = await api.get(`/presentations/product/${productId}`);
    return response.data;
  },

  create: async (productId, data) => {
    const response = await api.post(`/presentations/product/${productId}`, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/presentations/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/presentations/${id}`);
    return response.data;
  },
};

export default presentationService;
